/** X coordinate for a UTCTimestamp; uses nearest bar so event time need not match bar open exactly. */
export function timeToXMedia(chart, time) {
  const ts = chart.timeScale();
  const idx = ts.timeToIndex(time, true);
  if (idx === null) return null;
  return ts.logicalToCoordinate(idx);
}
